import { atom } from "recoil";

export const triggerSubmitAtom = atom({
	key: "triggerSubmitAtom",
	default: false,
});
